(() => {
  const drawer = document.querySelector('[data-menu-drawer]');
  const trigger = document.querySelector('[data-menu-toggle]');
  const close = document.querySelector('[data-menu-close]');
  const overlay = document.querySelector('[data-menu-overlay]');
  if (!drawer || !trigger || !overlay) return;
  let lastFocus;
  const setOpen = (open) => {
    document.body.classList.toggle('menu-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    trigger.setAttribute('aria-expanded', String(open));
    overlay.hidden = !open;
    if (open) {
      lastFocus = document.activeElement;
      window.requestAnimationFrame(() => drawer.querySelector('a, button, input')?.focus());
    } else if (lastFocus) lastFocus.focus();
  };
  trigger.addEventListener('click', () => setOpen(true));
  close?.addEventListener('click', () => setOpen(false));
  overlay.addEventListener('click', () => setOpen(false));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && document.body.classList.contains('menu-open')) setOpen(false); });
})();
